<template>
  <div class="">
    <div class="row">
      <div v-if="!showProcessingMessage && !showSpinner" class="cell col-5 pl-0">
        <span class="lighter">{{ $t("type.MaterialMapper") }}</span>
        <select
            v-model="selectedMaterialMapperId"
            class="custom-select bg-ui-secondary col-12 mb-2"
        >
          <option
              v-for="(item, index) in $store.getters.getMaterialmappersByListName(materialmapperList)"
              :key="index"
              :value="item.id"
          >
            {{ item.name }}
          </option>
        </select>

        <span class="lighter">{{ $t("type.MetaSet") }}</span>
        <select
            v-model="selectedMetaSetId"
            class="custom-select bg-ui-secondary col-12 mb-2"
            v-on:change="loadMetaFields()"
        >
          <option
              v-for="(item, index) in $store.getters.getMetaSets"
              :key="index"
              :value="item.id"
          >
            {{ item.name }}
          </option>
        </select>

        <span class="lighter">{{ $t("metaSetMaterialField") }}</span>
        <select
            v-model="selectedMaterialFieldId"
            class="custom-select bg-ui-secondary col-12 mb-2"
        >
          <option value=""></option>
          <option
              v-for="(item, index) in $store.getters.getMetaFieldsByListName(selectedMetaSetId)"
              :key="index"
              :value="item.id"
          >
            {{ item.description ? item.description : item.name }}
          </option>
        </select>

        <span class="lighter">{{ $t("metaSetColorField") }}</span>
        <select
            v-model="selectedColorFieldId"
            class="custom-select bg-ui-secondary col-12"
        >
          <option value=""></option>
          <option
              v-for="(item, index) in $store.getters.getMetaFieldsByListName(selectedMetaSetId)"
              :key="index"
              :value="item.id"
          >
            {{ item.description ? item.description : item.name }}
          </option>
        </select>
        <div
            slot="buttonsRight"
            :deactivated="canStartTask"
            :class="['settings-button d-inline-block mb-3 mt-3', canStartTask ? 'icon-rotate-animation make-longer-animation' : 'disabled']"
            @click="canStartTask ? startApplyMappingTask() : null"
        >
          <icon type=""/>
          {{ $t("applyMaterialFromMapper") }}
        </div>
      </div>
      <div v-if="showSpinner" class="cell col-5 pl-0 message">
        <loading-spinner/>
        <span class="ml-2">{{ $t("applyMaterialTaskStarting") }}</span>
      </div>
      <div v-if="showProcessingMessage" class="cell col-12 pl-0">
        <span>{{ $t("applyMaterialTaskStarted") }} </span>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner";
import Icon from "../Icon";

export default {
  name: "ApplyMaterialMapping",
  components: {
    LoadingSpinner,
    Icon
  },
  props: {
    assetId: {type: String, required: true},
  },
  data() {
    return {
      organizationId: "",
      materials: [],
      materialmapperList: "MaterialmapperList",
      forceReRenderKey: 1,
      selectedMaterialMapperId: "",
      selectedMetaSetId: "",
      selectedMaterialFieldId: "",
      selectedColorFieldId: "",
      showProcessingMessage: false,
      showSpinner: false,
      email: "",
    };
  },
  computed: {
    canStartTask() {
      return (
          this.selectedMaterialMapperId &&
          this.selectedMetaSetId &&
          this.selectedMaterialFieldId
      );
    },
  },
  beforeMount() {
    this.organizationId = this.$store.getters.getAssemblyOrganization(this.assetId);

    this.loadMaterialMappers();
    this.loadMetaSets();
  },
  methods: {

    loadMaterialMappers () {
      let args = {
        keep: {
          filter: {
            schemaName: "schemaName eq sfx.materialMapper",
            default: "organizationId eq " + this.organizationId,
          },
        },
      };
      this.$store.dispatch("loadMaterialmappers", args);
    },
    loadMetaSets() {
      let args = {add: {}};
      args.add.filter = {
        default: "organizationId eq " + this.organizationId
      };
      this.$store.dispatch("loadMetaSets", args);
    },
    loadMetaFields() {
      this.$store.dispatch("loadMetaFields", {
        keep: {
          id: this.selectedMetaSetId,
        },
        listName: this.selectedMetaSetId,
      });
    },
    startApplyMappingTask() {
      this.showSpinner = true;
      let configJson = JSON.stringify({
        mapperId: this.selectedMaterialMapperId,
        sourceMetaSetId: this.selectedMetaSetId,
        sourceMaterialMetaFieldId: this.selectedMaterialFieldId,
        sourceColorMetaFieldId: this.selectedColorFieldId,
        email: this.$store.getters.getUserEmail(this.$store.getters.getCurrentUserId),
                sendMails: true,
        language: this.$cookies.get('lang')
      });

      if (this.selectedMaterialFieldId || this.selectedColorFieldId) {
        this.$store.dispatch("clientAssetToPipeline", {
          id: this.assetId,
          type: "applyMaterial",
          config: configJson,
        }).then(() => {
          this.$emit('triggered')
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.message {
  display: flex;
}
.custom-select {
  color: #fff;
}
</style>
